import React, { useContext, useEffect } from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import Loading from "./pages/Loading/Loading";
import LoadingContext from "./store/loading-context";
//import { FloatingWhatsApp } from "react-floating-whatsapp";

import Routes from "./routes";

const App = () => {
  const loadingCtx = useContext(LoadingContext);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const authorization = params.get("authorization");

    if (!authorization) {
      return;
    }
  };

  return (
    <React.Fragment>
      {loadingCtx.isLoading && <Loading />}
      {/* 
      <FloatingWhatsApp
        phoneNumber={917890090500}
        accountName="Formax Pay"
        avatar="/images/favicon.png"
        allowEsc
        allowClickAway
        notification
        notificationSound
      /> */}

      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
